import {Loading} from 'element-ui'

let loading

function showLoad (text='加载中……') {
  loading = Loading.service({
    lock: true,
    text
  })
}

function hideLoad () {
  loading.close()
}

export {showLoad, hideLoad}



// WEBPACK FOOTER //
// ./src/tools/loading.js